module.exports = new __parcel__URL__("promos_base2024_3_0_image.4779e79c.png").toString();